<template>
  <div id="profile-pic-demo ">
    <b-img :src="banner" fluid v-if="banner && typeof banner == 'string'" class="my-2" />

    <vue-file-agent
      class="profile-pic-upload-block"
      ref="profilePicRef"
      :multiple="multiple"
      :deletable="false"
      :meta="false"
      :editable="true"
      :compact="false"
      :accept="'image/*'"
      :helpText="'فایل مورد نظر را به اینجا کشیده و رها کنید.'"
      :errorText="{
        type: 'لطفا یک فایل انتخاب کنید.',
      }"
      v-model="profilePic"
      @select="onSelect($event)"
      @delete="fileDeleted($event)"
    >
      <template v-slot:after-inner>
        <span title="after-inner" class="btn btn-link btn-sm btn-block"></span>
      </template>
      <template v-slot:after-outer>
        <div title="after-outer d-flex justify-content-between">
          <!-- <button
            type="button"
            class="btn btn-primary"
            :class="{ disabled: uploaded || !profilePic }"
            @click="upload"
          >
            آپلود
          </button> -->
          <button
            type="button"
            class="btn"
            :class="[uploaded ? 'btn-danger' : 'btn-secondary']"
            v-if="profilePic"
            @click="removePic"
          >
            حذف
          </button>
          <div class="clearfix"></div>
        </div>
      </template>
    </vue-file-agent>
  </div>
</template>
<script>
import "vue-file-agent/dist/vue-file-agent.css";
import { BImg } from "bootstrap-vue";
export default {
  components: {
    BImg,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    banner: {
      type: null,
    },
  },
  data() {
    return {
      profilePic: null,
      uploaded: false,
      uploadUrl: "https://www.mocky.io/v2/5d4fb20b3000005c111099e3",
      uploadHeaders: {},
    };
  },
  watch: {
    profilePic(val) {
      if (val && val.file) {
        this.$emit("uploadImage", val.file);
      } else {
        this.$emit("uploadImage", "");
      }
    },
  },
  methods: {
    removePic: function () {
      var profilePic = this.profilePic;
      this.$refs.profilePicRef.deleteUpload(
        this.uploadUrl,
        this.uploadHeaders,
        [profilePic]
      );
      this.profilePic = null;
      this.uploaded = false;
    },
    fileDeleted(e) {
    },
    upload: function () {
      var self = this;
      this.$refs.profilePicRef
        .upload(this.uploadUrl, this.uploadHeaders, [this.profilePic])
        .then(function () {
          self.uploaded = true;
          setTimeout(function () {
            self.profilePic.progress(0);
          }, 500);
        });
    },
    onSelect: function (fileRecords) {
      this.uploaded = false;
    },
  },
};
</script>
<style>
#profile-pic-demo .drop-help-text {
  display: none;
}
#profile-pic-demo .is-drag-over .drop-help-text {
  display: block;
}
#profile-pic-demo .profile-pic-upload-block {
  border: 2px dashed transparent;
  padding: 20px;
  padding-top: 0;
}

#profile-pic-demo .is-drag-over.profile-pic-upload-block {
  border-color: #aaa;
}
#profile-pic-demo .vue-file-agent {
  width: 180px;
  float: left;
  margin: 0 15px 5px 0;
  border: 0;
  box-shadow: none;
}
.vue-file-agent.file-input-wrapper {
  border: none;
}
</style>
